import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

export default function Mentions() {
  return (
    <div className="rgpd">
      <Navbar />
      <div className="rgpd-content">
        <div className="rgpd-content-block">
          <h1>📜 Mentions légales – LM Couleurs</h1>
        </div>

        <div className="rgpd-content-block">
          <section>
            <h2>🧑‍💻 Éditeur du site</h2>
            <p>
              <strong>Responsable de la publication :</strong> Kyle Elore
            </p>
            <p>
              <strong>Contact :</strong> kyle.elore@gmail.com
            </p>
            <p>
              <strong>Statut :</strong> Auto entrepreneur
            </p>
            <p>
              <strong>Adresse :</strong> 56000 Vannes (adresse complète
              disponible sur demande)
            </p>

            <p>
              <strong>SIRET :</strong> 94103020700018
            </p>
          </section>
        </div>
        <div className="rgpd-content-block">
          <section>
            <h2>🖥 Hébergeur</h2>
            <p>
              <strong>Hébergement web :</strong> Netlify, Inc.
            </p>
            <p>
              <strong>Adresse :</strong> 2325 3rd Street, Suite 296, San
              Francisco, California 94107
            </p>
            <p>
              <strong>Site web :</strong>{" "}
              <a
                href="https://www.netlify.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                netlify.com
              </a>
            </p>
          </section>
        </div>

        <div className="rgpd-content-block">
          <section>
            <h2>🛡 Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu présent sur ce site (textes, images, logo,
              code) est la propriété exclusive de LM Couleurs. Toute
              reproduction, totale ou partielle, est interdite sans autorisation
              écrite préalable.
            </p>
          </section>
        </div>

        <div className="rgpd-content-block">
          <section>
            <h2>⚖ Responsabilité</h2>
            <p>
              Le site LM Couleurs s'efforce de fournir des informations exactes
              et à jour, mais ne peut garantir l'exactitude ou l'exhaustivité
              des contenus diffusés. En cas d’erreur, n’hésitez pas à nous
              contacter.
            </p>
          </section>
        </div>
        <div className="rgpd-content-block">
          <section>
            <h2>🧾 Données personnelles</h2>
            <p>
              La gestion des données personnelles est détaillée dans notre{" "}
              <a
                href="/politique-de-confidentialite"
                className="text-blue-600 underline"
              >
                politique de confidentialité
              </a>
              . Conformément au RGPD, vous disposez d’un droit d’accès, de
              rectification et de suppression de vos données. Pour toute
              demande, contactez-nous à : lmcoulmeurs56@gmail.com
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
